/* eslint-disable @nx/enforce-module-boundaries */
import {
  Button,
  HStack,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Text,
} from '@mybridge/ui';
import { forwardRef, useContext } from 'react';
import { JobsListingContext } from '../context';
import { ApplyJobForm } from '../apply-form';
import { useTranslator } from '@mybridge/ui/custom-hooks/useTranslation';
import { useDirection } from '@mybridge/ui/custom-hooks/useDirection';
export const ApplyJobModal = forwardRef(({ ...props }, ref) => {
  const { applyDisc, appliedJob } = useContext(JobsListingContext);
  const { title } = appliedJob ?? {};
  const { t } = useTranslator();
  const direction = useDirection();
  return (
    <>
      <Modal size={['full', 'full', '4xl']} {...(applyDisc ?? {})} {...props} scrollBehavior="inside" closeOnOverlayClick={false}>
        <ModalOverlay />
        {appliedJob?.id ? (
          <ModalContent>

            <ModalHeader>
              <Text>{t('createJob.applyTo') || "Apply to"} {title}</Text>
              <ModalCloseButton {...(direction === 'rtl') ? {left: '0.75rem', right: 'auto'} : {left: 'auto', right: '0.75rem'}} />
            </ModalHeader>
          
            <ModalBody>
              <ApplyJobForm appliedJob={appliedJob}/>
            </ModalBody>
            
          </ModalContent>
        ) : (
          <ModalContent>
            <ModalBody>
              <HStack justifyContent="center">
                <Text>{t('createJob.invalidJobSelected') || "Invalid job selected!"}</Text>
              </HStack>
            </ModalBody>
          </ModalContent>
        )}
      </Modal>
    </>
  );
});
